module.exports = __webpack_public_path__ + "Harshiniisvi-6be0b5cc.webp";